import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

/**
 * Copilot API slice — talks to the AI copilot backend endpoint at
 * /api/copilot/chat. Uses cookie-based auth via credentials: "include",
 * same pattern as IRAPI.
 */
export const CopilotAPI = createApi({
	reducerPath: "Copilot",
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/copilot`,
		credentials: "include",
	}),
	endpoints: (builder) => ({
		copilotChat: builder.mutation({
			query: ({ messages, draft, userMessage }) => ({
				url: `/chat`,
				method: "POST",
				body: { messages, draft, userMessage },
			}),
		}),
	}),
});

export const { useCopilotChatMutation } = CopilotAPI;
